/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import classnames from 'classnames';

import ProductLabel from 'components/atoms/ProductLabel';
import Link from 'components/atoms/Link';

import useMedia from 'util/hook/useMedia';
import { getImageFromStorage } from 'util/hook/getImageFromStorage';

import Linkto from 'images/icon/linkto.inline.svg';

import { NewsLabelMapping } from './config';

import styles from './index.module.css';

// news 的類型，對應標籤的 style
export type NewsType = '最新公告' | '會員活動' | '媒體報導' | '私密基地' | '性平之路';

export interface NewsCardProperty {
	id?: number;
	image: string;
	title: string;
	category: NewsType;
	beginAt: string;
	link: string;
	className?: string;
}
/**
 * 首頁最新消息卡片
 * @param param0
 * @returns
 */
const NewsCard: React.FC<NewsCardProperty> = ({
	image,
	title,
	category,
	beginAt,
	link,
	className,
}) => {
	const media = useMedia();
	return (
		<Link className={classnames(styles.newsCard, className)} to={link}>
			<div className={styles.imgContainer}>
				<img src={getImageFromStorage(image)} alt="news" loading='lazy'/>
			</div>
			<div className={styles.infos}>
				<h3 className={styles.title}>{title}</h3>
				<div className={styles.row}>
					<ProductLabel {...NewsLabelMapping[category]} />
					<p className={styles.time}>{beginAt}</p>
				</div>
			</div>
			{media === 'desktop' && (
				<div className={styles.linkto}>
					<Linkto />
				</div>
			)}
		</Link>
	);
};

export default NewsCard;
